__webpack_require__.p = "/badge-component-refactor/referrals/";